<template>
  <f-form-group
    v-if="field_visible"
    :field-errors="fieldErrors"
    :required="field.required"
    :label="field_label"
    :hide-label="hideLabel"
    :horizontal="horizontal"
  >
    <div v-if="!is_disabled">
      <b-form-textarea
        :label="field_label"
        :value="field_value"
        @input="on_input"
        v-bind="field.params"
        v-if="!is_html"
      ></b-form-textarea>
      <vue-editor
        :label="field_label"
        :value="field_value"
        @input="on_input"
        output="html"
        v-bind="field.params"
        v-if="is_html"
      ></vue-editor>
    </div>

    <div
      class="border rounded-sm p-2 bg-light"
      v-html="field_value"
      v-if="is_disabled"
    ></div>
  </f-form-group>
</template>

<script>
import FormWidgetMixin from "../FormWidgetMixin.js";
import FFormGroup from "../FFormGroup.vue";
import { VueEditor } from "vue2-editor";

export default {
  name: "TextAreaWidget",
  components: { FFormGroup, VueEditor },
  mixins: [FormWidgetMixin],
  computed: {
    is_html() {
      return this.field.params.layout == "html";
    },
  },
};
</script>
